import { Component, Input, OnInit, EventEmitter } from '@angular/core';
import { TranslationsService } from '../../core/translations/translations.service';
import { AppStorageService } from "../../app.storage.service";
import { FranchiseService } from '../../core/services/franchise.service';
import { BranchService } from '../../core/services/branch.service';
import { DeliveryGuyService } from '../../core/services/delivery-guy.service';
import { OrderAppModel } from '../../models/order/order-app.model';
import { environment } from '../../../environments/environment';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { DeviceDetectorService } from 'ngx-device-detector';
import { StorageValueEnum } from '../../enums/advanced/storage-value.enum';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { datepickerAnimation } from 'ngx-bootstrap/datepicker/datepicker-animations';
import { ElectronService } from 'ngx-electron';
import { url } from 'inspector';
import {BranchTabEnum} from "../../enums/branch-tab.enum";
import { ActivatedRoute } from '@angular/router';
import { BranchAppModel } from '../../models/franchise-branch/branch-app.model';

// declare var electron: any;

@Component({
  selector: 'app-branches',
  templateUrl: './branches.component.html',
  styleUrls: ['./branches.component.css']
})
export class BranchesComponent implements OnInit {
 // @ViewChild('cancelOrderModal', { static: false }) public cancelOrderModal: ModalDirective;
  @Input()
  public franchise: any;
public fromBranchId: number;
  public franchiseId: number;
  private deviceInfo: any;
  public branchActiveTab: BranchTabEnum;

  private userColumnsKey: string;
  private userSavedColumns: any[];
  public branches: BranchAppModel[];
  public deletedBranches: BranchAppModel[];
  public branchToDelete: BranchAppModel;
  public showLoader:boolean;

  public currentFranchise:any;
  public deliveryGuys: [];
  public filterQuery = '';
  public fieldsToFilter: string[] = ['Id', 'Name'];
  public selectedOrderStatusId: number;
  public showDetailsRow: boolean = false;
  public expandedIndex: number;
  
  public orderStatusId: number;
  public fromDate: Date;
  public lastOrderId: number;

  public dropdownColumnsList = [];
  public selectedColumns = [];
  public dropdownSettings: IDropdownSettings = {};
  public colspan: number;
  public isCollapsed: boolean = true;


  constructor(private translationService: TranslationsService,
    private franchiseService: FranchiseService,
    private branchService: BranchService,    
    private route: ActivatedRoute,
    private deviceService: DeviceDetectorService,
    public appStorageService: AppStorageService) {


  }

  ngOnInit(): void {
    this.showLoader = true;

    this.route.params.subscribe(params => {
      //this.idParam= params[`id`];
      console.log("params",params);
      if (params && params["franchiseId"]) {
        this.franchiseId = params["franchiseId"];
        this.getFranchise();
         this.getAllBranches();
      } else {
        if (this.franchise) {
          this.franchiseId = this.franchise.Id;
          this.getAllBranches();
        }
        console.log("branch component: No franchiseId");
      }
     
    });
   
    this.deviceInfo = this.deviceService.getDeviceInfo();  
   
  }

  public getFranchise() {
    this.franchiseService.getFranchise(this.franchiseId).subscribe((response) => {
      if (response) {
        console.log('getFranchise', response);
        this.franchise = response; 
      }
    }, error => {
      console.log('getFranchise - Error', error);
    });
  } 
  
  isMobileMode(): boolean {
    return this.deviceService.isMobile();
  }

  public copyFranchiseMenuToBranch(branchId) {
    this.showLoader = true;

    this.branchService.CopyFranchiseMenuToBranch(this.franchiseId, branchId).subscribe((response) => {
      this.showLoader = false;

      if (response == true) {
        console.log('CopyFranchiseMenuToBranch', response);
        document.getElementById("snackbar-success").classList.add("show");        
        setTimeout(() => { document.getElementById("snackbar-success").classList.remove("show"); }, 2000);
         
      } else {
        console.log('CopyFranchiseMenuToBranch', response);
        document.getElementById("snackbar-error").classList.add("show");        
        setTimeout(() => { document.getElementById("snackbar-error").classList.remove("show"); }, 2000);
      }
    }, error => {
      console.log('copyFranchiseMenuToBranch - Error', error);
    });
  } 

  //CopyBranchMenuToBranch
  public copyBranchMenuToBranch(fromBranchId, toBranch) {
    this.showLoader = true;

    this.branchService.CopyBranchMenuToBranch(fromBranchId, toBranch.Id).subscribe((response) => {
      this.showLoader = false;
      toBranch.copy = false;
      if (response == true) {
        console.log('CopyBranchMenuToBranch', response);
        document.getElementById("snackbar-success").classList.add("show");        
        setTimeout(() => { document.getElementById("snackbar-success").classList.remove("show"); }, 2000);
         
      } else {
        console.log('CopyBranchMenuToBranch', response);
        document.getElementById("snackbar-error").classList.add("show");        
        setTimeout(() => { document.getElementById("snackbar-error").classList.remove("show"); }, 2000);
      }
    }, error => {
      console.log('CopyBranchMenuToBranch - Error', error);
    });
  } 

  

  public getAllBranches() {
    this.branchService.getAllBranches(this.franchiseId).subscribe((response) => {
      if (response) {
        console.log('getAllBranches', response);
        this.branches = response.filter((b)=>{return b.Active});
         console.log('branches', this.branches);
        this.deletedBranches = response.filter((b)=>{return !b.Active});
        console.log('deletedBranches', this.deletedBranches);
        this.showLoader = false;

      }
    }, error => {
      console.log('getAllBranches - Error', error);
    });
  }

  public delete() {
    this.branchService.deleteBranch(this.branchToDelete.Id).subscribe((response) => {
      if (response) {
        console.log('deleteBranch', response);
        this.branchToDelete.Active = false;
        this.getAllBranches();
        
      }
    }, error => {
      console.log('delete branch - Error', error);
    });
  }

  public undelete(branch) {
    this.branchService.undeleteBranch(branch.Id).subscribe((response) => {
      if (response) {
        console.log('undeleteBranch', response);
        branch.Active = true;
        this.getAllBranches();
        
      }
    }, error => {
      console.log('undeleteBranch - Error', error);
    });
  }


  public stringedDateFomat(stringedDate) {
    let timeArr = stringedDate.split(' ')[1].split(':');
    var strTime = '';

    var hours = +timeArr[0];
    var minutes = +timeArr[1];
    var hoursStr: String;
    var minutesStr: String;


    if (environment.language == 'en') {
      var ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutesStr = minutes < 10 ? '0' + minutes.toString() : minutes.toString();
      strTime = hours + ':' + minutesStr + ' ' + ampm;
    } else {
      hoursStr = hours < 10 ? '0' + hours.toString() : hours.toString();
      minutesStr = minutes < 10 ? '0' + minutes.toString() : minutes.toString();
      strTime = hoursStr + ':' + minutesStr;
    }

    return strTime;
  }


  

  expandRow(index: number, franchise): void {
   
    this.currentFranchise = franchise;
    this.appStorageService.franchise = franchise;
    this.expandedIndex = index === this.expandedIndex ? -1 : index;
  }

  setCurrentBranch(branchTab:BranchTabEnum) {
   // this.currentFranchise = franchise;
    //this.appStorageService.franchise = franchise;
   // this.appStorageService.branch=branch;
    this.appStorageService.branchTabEnum = branchTab;
    console.log("branchActiveTab", this.appStorageService.branchTabEnum);
  }


  public checkDisplay(columnName: string): boolean {
    if (this.selectedColumns.find(col => col.col_id === columnName)) {
      return true;
    }
    return false;
  }

  
  
}

